import createContext from '@ant-design/create-react-context';
const MenuContext = createContext({
    inlineCollapsed: false,
});
export default MenuContext;
